const GalleryData = (() => {
    const images = import.meta.glob('../assets/images/Gallery/**/*.{jpg,jpeg,png,gif,webp}', { eager: true });

    const groupedImages = Object.entries(images).reduce((acc, [path, module]) => {
        const match = path.match(/\/Gallery\/([^/]+)\//);
        const dirName = match ? match[1] : 'Ungrouped';

        if (!acc[dirName]) acc[dirName] = [];

        acc[dirName].push({
            imageLink: module.default,
            altText: `${dirName} Image`,
        });

        return acc;
    }, {});

    return Object.entries(groupedImages).map(([dirName, images]) => ({
        label: dirName,
        value: dirName,
        images,
    }));
})();

export default GalleryData;
